import api from "./api";

export const listGlobalSettings = async (query = {}) => {
  const { data } = await api.get("/admin/v1/settings", { params: query });
  return data;
};

export const updateGlobalSetting = async (key, value) => {
  const { data } = await api.put("/admin/v1/settings", { key, value });
  return data;
};

export const bulkUpdateSettings = async (settings) => {
  const { data } = await api.post("/admin/v1/settings/bulk", { settings });
  return data;
};

export const listHelps = async (query = {}) => {
  const { data } = await api.get("/admin/v1/helps", { params: query });
  return data;
};

export const createHelp = async (payload) => {
  const { data } = await api.post("/admin/v1/helps", payload);
  return data;
};

export const updateHelp = async (id, payload) => {
  const { data } = await api.put(`/admin/v1/helps/${id}`, payload);
  return data;
};

export const deleteHelp = async (id) => {
  const { data } = await api.delete(`/admin/v1/helps/${id}`);
  return data;
};
